const thousandFormat = {
  bind(el) {
    const formatNumber = (value) => {
      if (!value) return '';
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 添加千分位
    };

    const unformatNumber = (value) => {
      if (!value) return '';
      return value.replace(/,/g, ''); // 去掉逗号
    };

    el.addEventListener('input', (event) => {
      const input = event.target;

      // 获取去掉逗号的值并保留数字
      const rawValue = unformatNumber(input.value).replace(/[^0-9]/g, '');

      // 格式化为千分位分隔
      const formattedValue = formatNumber(rawValue);

      // 更新显示值
      if (input.value !== formattedValue) {
        input.value = formattedValue; // 更新显示值
      }
    });

    el.addEventListener('focus', (event) => {
      const input = event.target;
      input.value = unformatNumber(input.value); // 聚焦时去掉逗号
    });

    el.addEventListener('blur', (event) => {
      const input = event.target;
      input.value = formatNumber(unformatNumber(input.value)); // 失焦时重新格式化
    });
  }
};

export default {
  thousandFormat
};



// WEBPACK FOOTER //
// ./src/utils/directives.js